module.exports = __webpack_public_path__ + "img/24.9d084dc2.jpg";